// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3bbNk","primary":"button_primary__1RLMp"};